var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0718 1.98511H7.75294C4.13951 1.98511 1.98535 4.13883 1.98535 7.75153V16.0588C1.98535 19.6814 4.13951 21.8351 7.75294 21.8351H16.0618C19.6753 21.8351 21.8294 19.6814 21.8294 16.0687V7.75153C21.8394 4.13883 19.6852 1.98511 16.0718 1.98511Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5028 15.4634C10.3043 15.4634 10.1156 15.384 9.97667 15.245L7.16733 12.4362C6.87945 12.1484 6.87945 11.672 7.16733 11.3842C7.45521 11.0964 7.93171 11.0964 8.21959 11.3842L10.5028 13.6669L15.6053 8.56548C15.8932 8.27765 16.3697 8.27765 16.6575 8.56548C16.9454 8.8533 16.9454 9.3297 16.6575 9.61753L11.0289 15.245C10.89 15.384 10.7013 15.4634 10.5028 15.4634Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.ff198a39.svg";
export { ForwardRef as ReactComponent };